export const mainTitles = {
  paper: "투고 정보",
  review: "심사위원 현황",
  result: "게재 여부",
  comment: "심사 내용",
};

export const paperInfofields = [
  {
    idx: 1,
    label: "투고일",
    key: "submitted_at",
  },
  {
    idx: 2,
    label: "제목",
    key: "title",
  },
  {
    idx: 3,
    label: "제목(영문)",
    key: "title_eng",
  },
  {
    idx: 4,
    label: "키워드",
    key: "keyword",
  },
  {
    idx: 5,
    label: "키워드(영문)",
    key: "keyword_eng",
  },
  // {
  //   idx: 6,
  //   label: "초록",
  //   key: "abstract_kor",
  //   type: "html",
  // },
  // {
  //   idx: 7,
  //   key: "abstract_eng",
  //   label: "초록(영문)",
  //   type: "html",
  // },
  {
    idx: 8,
    key: "file_path",
    label: "논문 유사도 검사",
    type: "file",
  },
  {
    idx: 9,
    key: "member_name",
    label: "투고자명",
    type: "only_maneger",
  },
  {
    idx: 10,
    key: "member_organization",
    label: "투고자 소속",
    type: "only_maneger",
  },
  {
    idx: 11,
    key: "member_email",
    label: "투고자 이메일",
    type: "only_maneger",
  }
];

export const finalResultOptions = [
  {
    idx: 1,
    label: "게재(80점 이상)",
    min_score: 80,
    max_score: 100,
  },
  {
    idx: 2,
    label: "수정 후 게재(70~79점)",
    min_score: 70,
    max_score: 79,
  },
  {
    idx: 3,
    label: "수정 후 재심(60~69점)",
    min_score: 60,
    max_score: 69,
  },
  {
    idx: 4,
    label: "게재 불가(60점 미만)",
    min_score: 0,
    max_score: 59,
  },
];
